// Central data for the VARNELLA landing page.

export const NAV_LINKS = [
  { label: "Studio", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Industries", href: "#industries" },
  { label: "Contact", href: "#contact" },
];

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_varnella-surfaces/artifacts/ueqendfb_logo.jpg";

export const HERO_IMAGE = "/varnella-hero.png";

export const ABOUT_IMAGE =
  "https://customer-assets.emergentagent.com/job_varnella-surfaces/artifacts/0p26b4u5_WhatsApp%20Image%202026-07-06%20at%2012.00.06%20PM.jpeg";

export const SERVICES = [
  {
    title: "Custom Wallpapers",
    blurb: "Bespoke patterns and textures printed to your exact palette and scale.",
    icon: "Wallpaper",
  },
  {
    title: "Designer Wall Art",
    blurb: "Signature murals and framed compositions crafted around each interior.",
    icon: "Frame",
  },
  {
    title: "Decorative Window Films",
    blurb: "Sculpted light through hand-designed films for privacy and drama.",
    icon: "PanelsTopLeft",
  },
  {
    title: "Privacy & Frosted Graphics",
    blurb: "Refined glass treatments engineered for boardrooms and residences.",
    icon: "Blinds",
  },
  {
    title: "Wardrobe Laminations",
    blurb: "Cabinet skins in stone, veneer and abstract textures — cut to millimetres.",
    icon: "Layers",
  },
  {
    title: "Ceiling Graphics",
    blurb: "Aerial artistry that transforms overlooked planes into focal points.",
    icon: "SquareStack",
  },
  {
    title: "Custom Vinyl Flooring",
    blurb: "Full-scale flooring stories in patterns and materials of your choosing.",
    icon: "Grid3x3",
  },
  {
    title: "Architectural Surface Films",
    blurb: "Column, pillar and structural cladding with luxury finishes.",
    icon: "Building2",
  },
  {
    title: "Branding Graphics",
    blurb: "Environmental branding that reads as architecture — never as signage.",
    icon: "Sparkles",
  },
  {
    title: "Healthcare Graphics",
    blurb: "Calming, hygienic surface systems designed for critical environments.",
    icon: "HeartPulse",
  },
  {
    title: "Retail Display Graphics",
    blurb: "Storytelling surfaces engineered for conversion and dwell time.",
    icon: "ShoppingBag",
  },
  {
    title: "Hospitality Surface Design",
    blurb: "Guest-facing environments composed as a single cinematic experience.",
    icon: "Hotel",
  },
];

export const PORTFOLIO = [
  {
    title: "Ashfield Residence",
    category: "Residential",
    tag: "residential",
    image:
      "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=1200&auto=format&fit=crop&q=80",
    span: "row-span-2",
  },
  {
    title: "The Rosewood Suite",
    category: "Hospitality",
    tag: "hospitality",
    image:
      "https://images.unsplash.com/photo-1621293954908-907159247fc8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwbW9kZXJuJTIwaG9zcGl0YWxpdHklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODMyNjc0OTl8MA&ixlib=rb-4.1.0&q=85",
    span: "",
  },
  {
    title: "Meridian Office",
    category: "Corporate",
    tag: "corporate",
    image:
      "https://images.unsplash.com/photo-1758448656990-398443036eb4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBvZmZpY2UlMjBidWlsZGluZyUyMGludGVyaW9yfGVufDB8fHx8MTc4MzI2NzUxMHww&ixlib=rb-4.1.0&q=85",
    span: "",
  },
  {
    title: "Northlake Hospital",
    category: "Healthcare",
    tag: "healthcare",
    image:
      "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=1200&auto=format&fit=crop&q=80",
    span: "",
  },
  {
    title: "Serene Reception",
    category: "Corporate",
    tag: "corporate",
    image:
      "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&auto=format&fit=crop&q=80",
    span: "row-span-2",
  },
  {
    title: "Aurora Retail",
    category: "Retail",
    tag: "retail",
    image:
      "https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?w=1200&auto=format&fit=crop&q=80",
    span: "",
  },
  {
    title: "Belvedere Villa",
    category: "Residential",
    tag: "residential",
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&auto=format&fit=crop&q=80",
    span: "",
  },
  {
    title: "Ceiling Study 04",
    category: "Hospitality",
    tag: "hospitality",
    image:
      "https://images.unsplash.com/photo-1776763019060-fa0663574ae6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwbW9kZXJuJTIwaG9zcGl0YWxpdHklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODMyNjc0OTl8MA&ixlib=rb-4.1.0&q=85",
    span: "",
  },
];

export const PORTFOLIO_FILTERS = [
  { label: "All Work", value: "all" },
  { label: "Residential", value: "residential" },
  { label: "Hospitality", value: "hospitality" },
  { label: "Corporate", value: "corporate" },
  { label: "Healthcare", value: "healthcare" },
  { label: "Retail", value: "retail" },
];

export const WHY_US = [
  { title: "Fully Custom Designs", body: "Every surface begins as a private sketch — never a template.", icon: "PenTool" },
  { title: "Premium Material Quality", body: "Sourced from a curated network of specialty manufacturers.", icon: "Award" },
  { title: "Precision Manufacturing", body: "Colour, scale and finish tolerances calibrated to museum standards.", icon: "Ruler" },
  { title: "Expert Installation", body: "In-house installers trained on multi-material environments.", icon: "Hammer" },
  { title: "Sustainable Solutions", body: "Low-VOC substrates and responsibly sourced pigments.", icon: "Leaf" },
  { title: "Design Consultation", body: "One-to-one studio sessions with our creative directors.", icon: "MessageCircle" },
  { title: "Fast Project Execution", body: "Concept to installation compressed without a compromise.", icon: "Zap" },
  { title: "Nationwide Service", body: "A single studio point of contact — coast to coast delivery.", icon: "Map" },
];

export const STATS = [
  { value: 15, suffix: "+", label: "Years of Craft" },
  { value: 520, suffix: "+", label: "Projects Delivered" },
  { value: 42, suffix: "", label: "Cities Served" },
  { value: 98, suffix: "%", label: "Client Retention" },
];

export const PROCESS_STEPS = [
  { title: "Consultation", body: "A private conversation to understand narrative, mood and function." },
  { title: "Site Measurement", body: "Laser-precise capture of every plane, joint and shadow line." },
  { title: "Concept Development", body: "Directional moodboards, palette studies and material sketches." },
  { title: "Custom Design", body: "Signature artwork rendered to your exact composition and scale." },
  { title: "Material Selection", body: "Substrate, finish and hardware selected as one integrated system." },
  { title: "Production", body: "Colour-managed print, film and lamination under studio supervision." },
  { title: "Installation", body: "White-glove installation with millimetre tolerances." },
  { title: "Final Handover", body: "A ceremonial reveal, care guide and long-term partnership." },
];

export const INDUSTRIES = [
  { name: "Residential", image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&auto=format&fit=crop&q=80" },
  { name: "Corporate Offices", image: "https://images.unsplash.com/photo-1758448656990-398443036eb4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBvZmZpY2UlMjBidWlsZGluZyUyMGludGVyaW9yfGVufDB8fHx8MTc4MzI2NzUxMHww&ixlib=rb-4.1.0&q=85" },
  { name: "Healthcare", image: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=1200&auto=format&fit=crop&q=80" },
  { name: "Hospitality", image: "https://images.unsplash.com/photo-1621293954908-907159247fc8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwbW9kZXJuJTIwaG9zcGl0YWxpdHklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODMyNjc0OTl8MA&ixlib=rb-4.1.0&q=85" },
  { name: "Retail", image: "https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?w=1200&auto=format&fit=crop&q=80" },
  { name: "Educational", image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&auto=format&fit=crop&q=80" },
  { name: "Commercial", image: "https://images.unsplash.com/photo-1517816743773-6e0fd518b4a6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwYXJjaGl0ZWN0dXJhbCUyMHN1cmZhY2V8ZW58MHx8fHwxNzgzMjY3NDk5fDA&ixlib=rb-4.1.0&q=85" },
  { name: "Luxury Villas", image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&auto=format&fit=crop&q=80" },
  { name: "Restaurants", image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200&auto=format&fit=crop&q=80" },
  { name: "Showrooms", image: "https://images.unsplash.com/photo-1611048268330-53de574cae3b?w=1200&auto=format&fit=crop&q=80" },
];

export const LOGOS = [
  "AURORA", "MERIDIAN", "NORTHFIELD", "ROSEWOOD", "STUDIO K", "PALLADIO", "MAISON N.", "ATRIUM",
];

export const BEFORE_AFTER = {
  before: "https://images.unsplash.com/photo-1503174971373-b1f69850bded?w=1600&auto=format&fit=crop&q=80",
  after: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=1600&auto=format&fit=crop&q=80",
};

export const CONTACT_INFO = {
  email: "admin@varnella.in",
  phone: "+91 95664 13125",
  whatsapp: "+91 95664 13125",
  address: "Chennai  ·  Coimbatore  ·  Bangalore",
  hours: "Mon – Sat  10:00 – 19:00 IST",
  socials: [
    { label: "Instagram", href: "https://instagram.com" },
    { label: "LinkedIn", href: "https://linkedin.com" },
    { label: "Pinterest", href: "https://pinterest.com" },
    { label: "Behance", href: "https://behance.net" },
  ],
};
